import { render, staticRenderFns } from "./WarehouseAllocationNewRules.vue?vue&type=template&id=17ca4770"
import script from "./WarehouseAllocationNewRules.vue?vue&type=script&lang=js"
export * from "./WarehouseAllocationNewRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports